import Slider from '@ui/components/Slider/Slider';
import SliderControl from '@ui/components/Slider/SliderControls';
import PropTypes from 'prop-types';
import styles from './ProductCardSlider.module.scss';
import React, { forwardRef } from 'react';

const ProductCardSlider = forwardRef(
  ({ children, sliderBreakpoints, ...defaultSettings }, ref) => {
    const sliderSettings = {
      slidesPerView: 1,
      spaceBetween: 20,
      breakpoints: sliderBreakpoints,
      touchStartPreventDefault: false,
      simulateTouch: false,
      ...defaultSettings,
    };

    return (
      <Slider ref={ref} {...sliderSettings}>
        <div className={styles.controlsContainer} data-no-slide="true">
          <SliderControl
            className={styles.controlButton}
            direction="left"
            size="small"
          />
          <SliderControl
            className={styles.controlButton}
            direction="right"
            size="small"
          />
        </div>
        {children}
      </Slider>
    );
  },
);

ProductCardSlider.propTypes = {
  children: PropTypes.node.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  sliderBreakpoints: PropTypes.object,
};

ProductCardSlider.defaultProps = {
  sliderBreakpoints: {
    576: {
      slidesPerView: 'auto',
    },
  },
};

ProductCardSlider.displayName = 'ProductCardSlider';

export default ProductCardSlider;
